<template>
  <div class="report">
    <mu-container>
      <mu-form
        :model="form"
        class="mu-demo-form"
        label-position="top"
        label-width="100"
      >
        <mu-row gutter>
          <mu-select
            label="请选择机构"
            multiple
            chips
            v-model="form.center_id"
            full-width
            @change="getIncomeCost()"
          >
            <mu-option label="全部机构" :value="0"></mu-option>

            <mu-option
              v-for="item in cost_centers"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            ></mu-option>
          </mu-select>
        </mu-row>
      </mu-form>
    </mu-container>
    <mu-container>
      <mu-row>
        <el-table
          v-loading="loading"
          :data="income_costs"
          border
          show-summary
          stripe
          style="width: 100%; text-align: center"
          class="budget_list"
          :summary-method="getSummaries"
          height="600"
          ref="table"
        >
          <el-table-column prop="cost_account.title" label="月份" fixed="left">
            <template slot-scope="scope">
              <span
                @click="lookup(scope.row)"
                type="text"
                style="color: #3f51b5"
                >{{ scope.row.month }}</span
              >
            </template>
          </el-table-column>
          <!-- <el-table-column prop="budget_year" label="预算年月">
          </el-table-column> -->
          <el-table-column prop="collected" sortable label="当月收款">
            <template slot-scope="scope">
              <span>{{  parseInt(scope.row.collected).toLocaleString() }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="cost" sortable label="当月支出">
            <template slot-scope="scope">
              <span>{{  parseInt(scope.row.cost).toLocaleString() }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="profit" sortable label="净流量">
            <template slot-scope="scope">
              <span>{{  parseInt(scope.row.profit).toLocaleString() }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="budget_rest" sortable label="剩余">
            <template slot-scope="scope">
              <span>{{ scope.row.budget_rest.toLocaleString()}}</span>
            </template>
          </el-table-column> -->
        </el-table>
      </mu-row>
    </mu-container>

    <Footer active="Report"></Footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "../../components/Report/Footer.vue";

export default {
  name: "Home",
  components: {
    Footer,
  },
  data() {
    return {
      form: {
        center_id: [0,],
      },
      cost_centers: [],
      income_costs: [],
      columns: [
        { title: "月份", name: "month" },
        // { title: "预算年月", name: "budget_year", align: "center" },
        {
          title: "当月收款",
          name: "collected",
          align: "center",
          sortable: true,
        },
        { title: "当月支出", name: "cost", align: "center", sortable: true },
        { title: "净流量", name: "profit", align: "center", sortable: true },
      ],
      loading: true,
    };
  },
  created() {
    document.title = "收入费用一览表（按机构）";
    this.getCostCenter();
    this.getIncomeCost();
  },
  methods: {
    getCostCenter() {
      this.$http.post("getcostcenter").then((res) => {
        console.log(res);
        if (res.data.code != 200) {
          console.log(res.data.msg);
        }
        this.cost_centers = res.data.data;
      });
    },

    getIncomeCost() {
      console.log(this.form);
      this.$http.post("report/income_cost_hospital", this.form).then((res) => {
        if(res.data.code == 204){
          this.$router.push({name:'Login'});  
          return false;
        }
        if (res.data.code != 200) {
          this.$dialog
            .alert({
              message: res.data.msg,
            })
            .then(() => {
              this.$router.push({ name: "Report" });
            });
        }
        this.income_costs = res.data.data;
        this.loading = false;
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = parseInt(sums[index]).toLocaleString();
          // console.log(sums[index])
          // sums[index] += ' 元';
        } else {
          // sums[index] = 'N/A';
          sums[index] = "";
        }
      });

      return sums;
    },
  },
  updated(){
    this.$nextTick(() => {
      this.$refs['table'].doLayout();
    }) 

  }
};
</script>
<style scoped>
.flow {
  font-size: 14px;
}
.mu-row {
  border-collapse: collapse;
}
.mu-col {
  margin: 0px -1px -1px 0px;
  border: solid #000 1px;
  padding: 4px 10px;
  line-height: 20px;
  text-align: left;
}
.mu-form-item {
  min-height: 12px !important;
}
</style>

<style>
.budget_list .cell {
  text-align: center;
  font-weight: bold;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.budget_title {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 9999;
}
.budget_detail {
  margin: 75px auto 10px auto;
}
.budget_detail .cell {
  text-align: center;
  font-weight: bold;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.report_table {
  width: 100% !important;
}
.report_table .mu-table-header {
  width: 100% !important;
}

.report {
  margin-bottom: 90px;
  padding: 5px;
}
.report .amount {
  text-align: center;
  font-weight: bold;
}
.select_top {
  font-weight: bold;
  text-align: center;
  color: #000000;
  margin: 10px auto;
  font-size: 20px;
}
.mu-dialog-fullscreen .mu-dialog-body {
  padding: 0;
  max-height: 1200px !important;
}
</style>


